// The array contains all posible types by Aplil 6, 2021
// and types that must not be printed are commented
export const acceptedFieldTypes = [
    //"ConditionalSectionsOnly",
    //"ConditionalFieldsOnly",
    //"ConditionalRowsOnly",
    //"ListColumnsCopy",
    //"MoreOptions",
    //"LocalStockPlugin",
    "LocalTicketPlugin",
    "EmailAlertPlugin",
    "RemoteCallPlugin",
    //"PdfFusionPlugin",
    //"LocalUpdatelistPlugin",
    "TextField",
    "NumberField",
    "DateField",
    "TimeField",
    "CheckField",
    "OptionField",
    "ObjectSelectorField",
    "QRcodeField",
    "PhotoField",
    "AttachsField",
    "GpsField",
    "CalculatedField",
    "ConcatenatedField",
    "GraphField",
    "SignatureField"
]